// -------------------------------------
// Made by Dreamlab in console
// -------------------------------------
(function($) {

  console.log("Made by Dreamlab (https://www.dreamlab.nl)");

})(jQuery);